
import React, { useCallback, useEffect, useState } from 'react';
import MutualLoginRequest from '../request/MutualLoginRequest'
import { useCustomContext } from './AuthContext';

//components
import MobileLogin from './MobileLogin';
import Home from './Home';

//logos
import { NewMutualLogoLogin } from "./icons/Login";

//styles
import { createTheme, ThemeProvider } from '@mui/material/styles';

//Material UI
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { Grid, Stack } from '@mui/material';

//firebase
import { firebaseConfig } from '../utils/FirebaseConfig';
import firebase from '../firebase';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

import { setPersistence, inMemoryPersistence } from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

import AlertMessage from './AlertMessage';
import { useLocation } from 'react-router-dom';

var request: MutualLoginRequest;
const app = firebase.initializeApp(firebaseConfig);
initializeAppCheck(app, {
	provider: new ReCaptchaEnterpriseProvider('6LcDKOonAAAAAJcRPLKgPNYGYIqzrg8uHOtjwrPj'),
	isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
});
const auth = firebase.auth();
let ui: firebaseui.auth.AuthUI;

function startAuth() {
  ui.start('#firebaseui-auth-container', {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      'apple.com',
      firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ]
  });
}

setPersistence(auth, inMemoryPersistence).then(() => {
  ui = new firebaseui.auth.AuthUI(auth);
  startAuth();
});

export const forgotPassword = { color: '#6D6E71', textDecoration: 'none', fontFamily: 'Lato', fontWeight: '700', cursor: 'pointer' }

export const theme = createTheme({
  palette: {
    primary: {
      main: '#38ABFF',
    },
    secondary: {
      main: '#272525'
    },
  },
  shape: {
    borderRadius: 15
  },
  typography: {
    fontFamily: 'Lato',
  },
});

const providerMap = {
  phone: 'phone',
  'google.com': 'google',
  'apple.com': 'apple',
  'facebook.com': 'facebook'
};

export default function Login() {

  const {setWidthContext} = useCustomContext()

  const [isLogged, setIsLogged] = useState(false);
  const [width, setWindowWidth] = useState(0);
  const [mobileLogin, setMobileLogin] = useState<boolean>(false);
  const [accountNotFound, setAccountNotFound] = useState<boolean>(false)
  const [loginAttempts, setLoginAttempts] = useState<number>(0);

  const handleAccountNotFound = (status: boolean) => {
    setAccountNotFound(status);
    setLoginAttempts(loginAttempts + 1);
  }

  const responsive = {
    mobileView: width < 400
  }

  const updateDimensions = useCallback((): void => {
    const width = window.innerWidth;
    setWindowWidth(width);
    setWidthContext(width)
  }, [setWidthContext]);

  useEffect(() => {
    // @ts-ignore
    const unregisterAuthObserver = auth.onAuthStateChanged((signedInUser) => {
      // @ts-ignore
      if (signedInUser != null) {
        // @ts-ignore
        request = new MutualLoginRequest(signedInUser.multiFactor.user.accessToken, providerMap[signedInUser.providerData[0].providerId]);
      }
      setIsLogged(!!signedInUser)
    });
    return (): void => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    updateDimensions();
    return () => window.removeEventListener("resize", updateDimensions)
  }, [width, updateDimensions]);

  useEffect(() => {
    if (accountNotFound) {
      auth.signOut();
      ui.reset();
      startAuth();
    }
  }, [accountNotFound, loginAttempts]);

  const search = useLocation().search;
  const redirectQueryParam = new URLSearchParams(search).get('redirect_uri');

  if (!isLogged) {
    return (
      <React.Fragment>
        <CssBaseline />
        <Container maxWidth="sm" sx={responsive.mobileView ?
          { position: 'relative', top: '56px', padding: '0px', marginBottom: '55px' }
          :
          { position: 'relative', top: '100px', marginBottom: '200px' }}>

          <Box sx={responsive.mobileView ?

            // If adding login options, add 50 to the height for each option
            { bgcolor: '#FFFFFF', padding: '30px', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '20px' }
            :
            { bgcolor: '#FFFFFF', width: '430px', padding: '30px', margin: 'auto', borderRadius: '20px' }}>

            <Grid container item xs={12} justifyContent='center' flexDirection='row' style={{ width: 'fit-content', margin: responsive.mobileView ? '0' : 'auto' }}>
              <NewMutualLogoLogin />
            </Grid>

            {mobileLogin ?
              <MobileLogin />
              :
              <Stack direction="column" alignItems="center" spacing={2}>
                <ThemeProvider theme={theme}>
                  <div id="firebaseui-auth-container"></div>
                  {accountNotFound
                    ?
                    <AlertMessage type="invalid" isMobile={responsive.mobileView}>
                      We were unable to find a user that matched the login information you provided. Please try again.
                    </AlertMessage>
                    : null}
                </ThemeProvider>
              </Stack>
            }
          </Box>
        </Container>
      </React.Fragment>
    );
  }
  else {
    return (
      <Home
        queryParamUrl={redirectQueryParam}
        handleAccountNotFound={handleAccountNotFound}
        setMobileLogin={setMobileLogin}
        setIsLogged={setIsLogged}
        loginRequestProp={request}
        width={width}
      />
    )
  }
}
